(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("teddy", [], factory);
	else if(typeof exports === 'object')
		exports["teddy"] = factory();
	else
		root["teddy"] = factory();
})(this, () => {
return 